<div class="search-results">
  <div class="form-row align-items-center mb-3">
    <div class="col-auto">
      <button (click)="onResetSearch()" class="btn btn-sm btn-outline-light"><span class="fa-solid fa-chevron-left"></span>
    </button>
  </div>
  <div class="col">
    <span [innerHTML]="summary" class="d-block"></span>
  </div>
</div>

@for (searchResult of searchResults; track searchResult) {
  <scitis-search-result-item (menuItemSelected)="onMenuItemSelected($event)"
    [menuItem]="searchResult"
    [searchTerms]="searchTerms">
  </scitis-search-result-item>
}

@if (shouldShowLoadButton) {
  <button (click)="onLoadMoreItems()"
    class="btn btn-primary btn-block mt-2">
    @if (searchInProgress) {
      <span class="fa-solid fa-spinner fa-spin ml-0"></span>
    }
    @if (!searchInProgress) {
      <span class="fa-solid fa-angles-down"></span>
    }
    @if (searchInProgress) {
      <span translate>Loading...</span>
    }
    @if (!searchInProgress) {
      <span translate>Load more</span>
    }
  </button>
}


</div>